import { ComparatorStep } from '@kizi/comparator-core';

import { defaultFiltersTriplePlay } from '../../../components';

const overview: ComparatorStep = {
  path: 'overview',
  name: 'overview',
  fields: [
    {
      name: 'requestLogId',
    },
    {
      name: 'selectedProduct',
      validator: 'required',
    },
    { name: 'monthlyCosts', value: '[]' },
    { name: 'onceOffCosts', value: '[]' },
    {
      name: 'comparisonProducts',
    },
    {
      name: 'comparisonId',
      value: '',
    },
    {
      name: 'specificTvChannelOptions',
    },
    {
      name: 'filters',
      value: JSON.stringify({
        showPriceMode: ['month'],
        productTypes: ['internet', 'television'],
        monthlyPrice: [0, 100],
        suppliers: [],
        downloadSpeed: [50, 8000],
        signal: ['dsl', 'kabel', 'glasvezel'],
        extraOptions: [],
        onceOffCosts: [],
        deliveryTime: [],
        channelsPackages: [],
        specificTvChannel: [],
        bellen: [],
        installation: [],
        mobileProvider: [],
        energySupplier: [],
      }),
    },
    {
      name: 'defaultFilters',
      value: JSON.stringify({
        showPriceMode: ['month'],
        productTypes: ['internet', 'television'],
        monthlyPrice: [0, 100],
        suppliers: [],
        downloadSpeed: [50, 8000],
        signal: ['dsl', 'kabel', 'glasvezel'],
        extraOptions: [],
        onceOffCosts: [],
        deliveryTime: [],
        channelsPackages: [],
        specificTvChannel: [],
        bellen: [],
        installation: [],
        mobileProvider: [],
        energySupplier: [],
      }),
    },
    {
      name: 'filterGraphQL',
      value: JSON.stringify(defaultFiltersTriplePlay),
    },
    {
      name: 'isLoadingProducts',
      value: 'true',
    },
  ],
};

export default overview;
